import { MuiX, Mui } from "@osu/react-ui";
import { isValid, format as _format } from 'date-fns';
import { Fragment, useState } from "react";
import { mergeSxStyles } from "../../../../util/functions";

function DatePicker(props = {}) {
  const {
    label,
    description,
    helperText,
    id,
    modal,
    name,
    required,
    slotProps = {},
    error,
    value,
    onChange,
    format = 'MM/dd/yyyy',
    defaultValue: _defaultValue = new Date(),
    setValue,
    ...rest
  } = props;
  const descriptionId = `${id}-description`;
  const inputLabelId = `${id}-label`;
  const defaultValueDate = _defaultValue && new Date(_defaultValue)
  const defaultValue =  (defaultValueDate && isValid(defaultValueDate)) ? defaultValueDate : new Date()
  const [controlledDate, setControlledDate] = useState(defaultValue)
  const datePickerProps = {
    ...rest
  }
  let Component = MuiX.DatePicker
  if(format.toLowerCase().includes("hh")) {
    Component = MuiX.DateTimePicker
  }
  
  if(setValue) {
    datePickerProps.value = (value && isValid(new Date(value))) ? new Date(value) : value
    datePickerProps.onChange = (date) => {
        onChange && onChange(date)
        setValue && setValue(date, name)
    }
  } else {
    datePickerProps.value = controlledDate
    datePickerProps.onChange = (date) => {
      setControlledDate(date)
    }
  }

  return (
    <Fragment>
      <Mui.Box
        sx={{ display: "flex", flexDirection: "column", width: "fit-content" }}
      >
        {label && (
          <Mui.FormLabel
            variant="body1"
            component="label"
            id={inputLabelId}
            required={required}
            error={error}
          >
            {label}
          </Mui.FormLabel>
        )}
        {description && (
          <Mui.Typography id={descriptionId} variant="body2" component="span">
            {description}
          </Mui.Typography>
        )}
        <Component
          error={error}
          {...datePickerProps}
          id={id}
          name={name}
          format={format}
          sx={mergeSxStyles(datePickerProps?.sx, {
            '&.MuiPickersTextField-root fieldset.MuiPickersOutlinedInput-notchedOutline': !error ? {
              borderColor: 'inherit',
            } : {},
          })}
          slotProps={{
            ...slotProps,
            textField: {
              error,
              ...(slotProps?.textField || {}),
              onClick: (event) => {
                if(slotProps?.textField?.onClick) {
                  const _date = datePickerProps.value
                  const formatted = isValid(_date) ? _format(datePickerProps.value, format) : ''
                  slotProps.textField.onClick(event, formatted)
                }
              },
              helperText: helperText,
              inputProps: {
                error: error ? "true" : undefined,
                required,
                ...(slotProps?.textField?.inputProps || {}),
                // Ensure the input is accessible
                "aria-labelledby": label ? inputLabelId : undefined,
                "aria-describedby": description ? descriptionId : undefined
              },
            },
          }}
        />
      </Mui.Box>
    </Fragment>
  );
}

export default DatePicker;
